import { Play } from 'lucide-react';
import { ImagePreview } from 'v5/design-system/ImagePreview';
import { MediaBadge } from 'v5/design-system/MediaBadges';
import { MediaKindIcon } from './MediaKindIcon';
import { mediaKindOf } from './uploadedMedia';

/** What a thumbnail needs of a file. */
export type MediaThumbnailFile = {
  name: string;
  mimeType?: string;
  /** The image itself, or the file when it is no image. */
  src: string;
  /** A picture standing for a file that is no image, such as a video's frame. */
  poster?: string;
  /** The picture's original, shown when its resized copy doesn't load. */
  fallbackSrc?: string;
};

/** A file's thumbnail: the image, or its kind and name when there is none. */
export function MediaThumbnail({ item }: { item: MediaThumbnailFile }) {
  const kind = (
    <span className="flex size-full flex-col items-center justify-center gap-2 px-2 text-fg-muted">
      <MediaKindIcon media={item} className="size-8" />
      <span className="w-full truncate text-center text-xs">{item.name}</span>
    </span>
  );
  const isImage = mediaKindOf(item) === 'image';
  const picture = isImage ? item.src : item.poster;
  if (picture === undefined) return kind;
  return (
    <>
      <ImagePreview
        src={picture}
        noUpscale
        fallback={kind}
        // the tile is what drags, not the image inside it
        className="size-full [&_img]:pointer-events-none"
      />
      {!isImage && (
        <MediaBadge size="sm">
          {mediaKindOf(item) === 'video' ? (
            <Play className="fill-current" />
          ) : (
            <MediaKindIcon media={item} />
          )}
        </MediaBadge>
      )}
    </>
  );
}
